//import './App.css';
import Router from './core/router/Router';
function App() {
    return (<Router/>);
}

export default App;
